/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_PurchaseInputs */

const en_common_auth_gate_action_purchase = /** @type {(inputs: Common_Auth_Gate_Action_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`complete checkout`)
};

const zh_common_auth_gate_action_purchase = /** @type {(inputs: Common_Auth_Gate_Action_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成购买`)
};

/**
* | output |
* | --- |
* | "complete checkout" |
*
* @param {Common_Auth_Gate_Action_PurchaseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_purchase = /** @type {((inputs?: Common_Auth_Gate_Action_PurchaseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_PurchaseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_purchase(inputs)
	return zh_common_auth_gate_action_purchase(inputs)
});
export { common_auth_gate_action_purchase as "common.auth.gate.action.purchase" }